import React, { ButtonHTMLAttributes } from "react";
import twFocusClass from "utils/twFocusClass";

export interface ButtonCircleProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: string;
}

const ButtonCircleSmall: React.FC<ButtonCircleProps> = ({
  className = " ",
  size = " w-4 h-4 ",
  ...args
}) => {
  return (
    <button
      className={
        `ttnc-ButtonCircle items-center justify-center rounded-full !leading-none disabled:bg-opacity-70 bg-primary-700 hover:bg-primary-6000 text-neutral-50 ${className} ${size} ` +
        twFocusClass(true)
      }
      {...args}
    />
  );
};

export default ButtonCircleSmall;
